import type { FC, ReactNode } from 'react';
import type { BoxProps } from '@mui/material';
import { Box } from '@mui/material';

import { styles } from './Message.styles';

export interface MessageProps extends BoxProps {
  align?: string;
  children?: ReactNode;
  className?: string;
}

export const COMMON_MESSAGE_DATA_TEST_ID = 'common-message';

/**
 * This is a small component that displays a form  message (or several).
 * You can pass the actual message(s) (as string or component) as children.
 */
const Message: FC<MessageProps> = ({
  align = 'center',
  children,
  className,
  ...boxProps
}) => (
  <Box
    className={className}
    data-test-id={COMMON_MESSAGE_DATA_TEST_ID}
    sx={[
      styles.message,
      { textAlign: align },
      ...(Array.isArray(boxProps.sx)
        ? boxProps.sx
        : boxProps.sx
          ? [boxProps.sx]
          : []),
    ]}
  >
    {children}
  </Box>
);

export default Message;
